<template>
  <div
    :class="{
      input: true,
      additionalInput: $route.name === 'EditPharmacy',
      tootip:
        !user?.role.permissions.pharmacy.update &&
        $route.name === 'EditPharmacy'
    }"
  >
    <FormKit
      :type="type"
      :name="name"
      :id="id"
      :label="label"
      :value="value"
      :validation="validation"
      :placeholder="placeholder"
      :disabled="disabled"
      :preserve="preserve"
      :autocomplete="autocomplete"
      :forName="forName"
      :validationMessages="validationMessages"
      :accept="accept"
      :max="max"
      :min="min"
      :onkeydown="onkeydown"
      @change="(e) => $emit('change', e)"
    />
    <img
      v-if="
        $route.name === 'EditPharmacy' &&
        name !== 'name' &&
        name !== 'email' &&
        name !== 'phoneNumber' &&
        name !== 'pinCode' &&
        name !== 'deliveryKeepTime' &&
        name !== 'deliveryReminderMessagePeriod' &&
        name !== 'shelvesNumber'
      "
      :class="{
        closeInput: !user?.role.permissions.pharmacy.update
      }"
      src="@/assets/icons/CloseInput.svg"
      alt="Close Input"
      @click="$emit('closeInput', id)"
    />
    <span
      v-if="
        !user?.role.permissions.pharmacy.update &&
        $route.name === 'EditPharmacy'
      "
      class="tooltiptext"
    >
      {{ $t('enoughPermissions') }}
    </span>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapState } from 'vuex';

@Options({
  name: 'Input',
  props: [
    'id',
    'type',
    'value',
    'validation',
    'name',
    'forName',
    'label',
    'placeholder',
    'disabled',
    'preserve',
    'autocomplete',
    'forName',
    'validationMessages',
    'accept',
    'max',
    'min',
    'onkeydown'
  ],
  computed: {
    ...mapState('account', ['user'])
  }
})
export default class InputComponent extends Vue {}
</script>

<style lang="scss">
.formkit-form {
  .formkit-messages {
    display: none;
  }
  .input {
    .formkit-outer {
      .formkit-messages {
        display: block;
      }
    }
  }
}

.input {
  max-width: 536px;
  margin-bottom: 30px;
}

.additionalInput {
  width: 377px;
  margin-bottom: 30px;
  position: relative;
  img {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
  }
}

.tootip {
  position: relative;
  .tooltiptext {
    position: absolute;
    top: -30%;
    left: 50%;
    transform: translate(-50%, -100%);
    visibility: hidden;
    width: 150px;
    font-size: $elevenSize;
    line-height: $elevenSize;
    background: $label;
    color: $white;
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s;
    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: $label transparent transparent transparent;
    }
  }

  &:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }
}

.formkit-outer {
  font-family: 'Ubuntu-Regular';
  height: 48px;
  &:last-child {
    margin-bottom: 0;
  }
  .formkit-wrapper {
    position: relative;
    .formkit-inner {
      max-width: 536px;
      box-shadow: none;
      .formkit-input {
        width: 100%;
        height: 48px;
        font-size: 14px;
        border-radius: 8px;
        border: 0;
        padding: 0 0 0 15px;
        box-sizing: border-box;
        color: $main-text;
        font-family: 'Ubuntu-Regular';
        outline: none;
        &:focus {
          border: 1px solid $main-green;
        }
        &:disabled {
          background: $white;
        }
      }
    }
    .formkit-label {
      position: absolute;
      font-family: 'Ubuntu-Regular';
      top: -6px;
      left: 15px;
      padding: 0 5px;
      background: $white;
      color: $label;
      font-weight: 400;
      font-size: $twelveSize;
      line-height: $fourteenSize;
      z-index: 1;
    }
  }
}

.formkit-messages {
  margin: 3px 0;
  font-size: $twelveSize;
  line-height: $fourteenSize;
  font-weight: 400;
  .formkit-message {
    color: $red;
  }
}

/* Change the white to any color */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  box-shadow: 0 0 0 30px $white inset !important;
}
</style>
